export default "__VITE_ASSET__De5LDnQa__"